module.exports = __webpack_public_path__ + "static/media/logoorange.d3bc0368.png";